import React, { useState } from 'react'

import { PostContent } from 'components/blog/post-content'
import { DashboardLoading } from 'components/dashboard-loading'
import { DashboardLayout } from 'components/dashboard/dashboard-layout'
import { format } from 'date-fns'
import { ArrowLeft as ArrowLeftIcon } from 'icons/arrow-left'
import NextLink from 'next/link'
// import { PostContent } from 'src/sections/dashboard/blog/post-content'
import { useRouter } from 'next/router'
import Zoom from 'react-medium-image-zoom'
import { useQuery } from 'react-query'
import { getGeneratedBlogById } from 'services/group'
import {
  getGroupArticleImage,
  getGroupMemberProfileImageUrl,
  getTenantMainSite,
} from 'tenant'
import { slugify } from 'utils'

import {
  Avatar,
  Box,
  Button,
  Card,
  CardContent,
  Chip,
  Container,
  Stack,
  SvgIcon,
  Typography,
} from '@mui/material'

interface Comment {
  id: string
  authorAvatar: string
  authorName: string
  authorRole: string
  content: string
  createdAt: number
  isLiked: boolean
  likes: number
}
const renderSiteSlug = slug => {
  switch (slug) {
    case 'team':
      return 't'
    case 'agent':
      return 'a'
    case 'lender':
      return 'l'
    case 'office':
      return 'o'
    default:
      return
  }
}
const Page = () => {
  const router = useRouter()
  const { params } = router.query
  const [articleUrl, setArticleUrl] = useState<string>('')
  const [groupImage, setGroupImage] = useState<string>('')
  const {
    isLoading,
    status,
    isError,
    data: post,
    refetch,
  } = useQuery<any>(['getGeneratedBlog', ...params], getGeneratedBlogById, {
    onSuccess: data => {
      setArticleUrl(
        `${getTenantMainSite()}/${renderSiteSlug(data?.brandingGroup?.role)}/${
          data?.brandingGroup?.slug
        }/articles/${slugify(data?.category)}/${slugify(
          data?.title,
          false,
          '_',
        )}-${data?.id}`,
      )
      setGroupImage(
        getGroupMemberProfileImageUrl({
          groupId: data.brandingGroup.id,
          width: 300,
          profileImage: data.brandingGroup.displayInfo.company_image,
        }),
      )
    },
  })

  if (!post) {
    return (
      <Box
        display={'flex'}
        height={'90vh'}
        justifyContent={'center'}
        alignItems={'center'}
      >
        <DashboardLoading />
      </Box>
    )
  }

  const publishedAt = format(new Date(post.publishedAt), 'MMMM d, yyyy')
  const createdAt = format(new Date(post.createdAt), 'MMMM d, yyyy')

  const cover = post.imagePath
    ? getGroupArticleImage({
        groupId: Number(params[0]),
        articleImage: post.imagePath,
      })
    : 'https://www.realty.com/imagecdn/shared_assets/assets/default-profile-bg.png'

  return (
    <Box
      component="main"
      sx={{
        flexGrow: 1,
        py: 8,
        px: 2,
      }}
    >
      <Container maxWidth="lg">
        <Box display="flex" justifyContent={'space-between'} mb={5}>
          <NextLink color="text.primary" href={`/blog`} passHref>
            <Typography
              variant="subtitle2"
              sx={{
                alignItems: 'center',
                display: 'inline-flex',
                '&:hover': {
                  cursor: 'pointer',
                },
              }}
            >
              <SvgIcon sx={{ mr: 1 }}>
                <ArrowLeftIcon />
              </SvgIcon>
              <Typography variant="subtitle2">Cancel / Go back</Typography>
            </Typography>
          </NextLink>
          <Box sx={{ flexGrow: 1 }} />
          <Box display="flex" gap={2}>
            <Button href={articleUrl} target="_blank" variant="contained">
              View Post
            </Button>

            <Button
              onClick={() => {
                router.push(`/blog/edit/${params[0]}/${params[1]}`)
              }}
              variant="contained"
            >
              Edit Post
            </Button>
          </Box>
        </Box>

        <Stack spacing={3}>
          <div>
            <Chip label={post.category} />
          </div>
          <Typography variant="h3">{post.title}</Typography>

          <Stack alignItems="center" direction="row" spacing={2} sx={{ mt: 3 }}>
            <Avatar src={groupImage} />
            <div>
              <Typography variant="subtitle2">
                By {post?.brandingGroup?.displayInfo?.name} • {createdAt}
              </Typography>
            </div>
          </Stack>
        </Stack>

        <Zoom>
          <Box
            component="div"
            role="img"
            sx={{
              backgroundImage: `url(${cover})`,
              backgroundPosition: 'center',
              backgroundSize: 'cover',
              borderRadius: 1,
              height: 380,
              mt: 3,
            }}
          />
        </Zoom>
        {post.content && (
          <Container sx={{ py: 3 }}>
            <Card variant="outlined">
              <CardContent>
                <PostContent content={post.content} />
              </CardContent>
            </Card>
          </Container>
        )}
      </Container>
    </Box>
  )
}

Page.getLayout = page => <DashboardLayout>{page}</DashboardLayout>

export default Page
